import { useFormik } from "formik";
import {
  superadminGetComboMenuAdmin,
  superadminGetCompanyById,
  superadminUpdateCompany,
} from "helpers/backend_helpers";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import Zoom from "react-medium-image-zoom";
import Select from "react-select";
import { toast } from "react-toastify";
import {
  Col,
  Form,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import * as Yup from "yup";
import "../../../pages/Info/style.css";

const UpdateModalCompanies = ({ show, onCloseClick, getData, data }: any) => {
  const [detailData, setDetailData] = useState<any>({});
  const [comboMenu, setComboMenu] = useState<any>([]);
  const [selectedImage, setSelectedImage] = useState<any>(null);
  const [imageFile, setImageFile] = useState<File | null>(null);

  const getDetailData = async () => {
    await superadminGetCompanyById(data._id)
      .then((response: any) => {
        setDetailData(response);
      })
      .catch(() => {});
  };

  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: detailData?.name || "",
      initial: detailData?.initial || "",
      maxMember: detailData?.maxMember || "",
      adminMenus:
        detailData?.adminMenus?.map((cat: any) => ({
          value: cat.key,
          label: cat.readableName,
        })) || [],
      logo: detailData?.logo || "",
      address: detailData?.address || "",
      picName: detailData?.pic?.name || "",
      picEmail: detailData?.pic?.email || "",
      noId: detailData?.pic?.noId || "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Nama perusahaan harus diisi!"),
      picName: Yup.string().required("Nama PIC harus diisi!"),
      picEmail: Yup.string()
        .email("Format email tidak valid!")
        .required("Email PIC harus diisi!"),
      maxMember: Yup.string().required("Maksimal jumlah pengguna harus diisi!"),
      adminMenus: Yup.array().min(1, "Menu perusahaan harus diisi!"),
      logo: Yup.string(),
      address: Yup.string().required("Alamat harus diisi!"),
    }),
    onSubmit: (values) => {
      const formData = new FormData();

      formData.append("name", values.name);
      formData.append("picName", values.picName);
      formData.append("picEmail", values.picEmail);
      formData.append("address", values.address);
      formData.append("maxMember", values.maxMember);
      formData.append(
        "adminMenus",
        values.adminMenus.map((cat: any) => cat.value)
      );

      if (imageFile) {
        formData.append("logo", imageFile);
      }

      superadminUpdateCompany(data._id, formData)
        .then((response: any) => {
          onCloseClick();
          getData();
          toast.success(
            <div>
              Perusahaan <b>{response?.name}</b> berhasil diubah!
            </div>
          );
          validation.resetForm();
          setSelectedImage(null);
          setImageFile(null);
        })
        .catch(() => {});
    },
  });

  const getCombo = async () => {
    await superadminGetComboMenuAdmin()
      .then((response: any) => {
        setComboMenu(
          response.map((val: any) => {
            return { value: val.key, label: val.readableName };
          })
        );
      })
      .catch(() => {});
  };

  const handleImageChange = (event: any) => {
    const file = event.target.files[0];
    if (!file) return;

    setImageFile(file);

    const reader = new FileReader();
    reader.onload = (e: any) => {
      setSelectedImage(e.target.result);
    };
    reader.readAsDataURL(file);
  };

  useEffect(() => {
    if (!show) {
      validation.resetForm();
      setSelectedImage(null);
      setImageFile(null);
    }
  }, [show]);

  useEffect(() => {
    if (show) {
      getDetailData();
      getCombo();
    }
  }, [show]);

  return (
    <Modal
      size="lg"
      fade={true}
      isOpen={show}
      toggle={onCloseClick}
      centered={true}
    >
      <ModalHeader className="bg-light p-3" toggle={onCloseClick}>
        Edit Perusahaan
      </ModalHeader>
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          validation.handleSubmit();
          return false;
        }}
      >
        <ModalBody>
          <Row className="g-3">
            <Col lg={12}>
              <div className="text-center">
                <div className="position-relative d-inline-block">
                  <div className="position-absolute bottom-0 end-0">
                    <Label htmlFor="logo" className="mb-0">
                      <div className="avatar-xs cursor-pointer">
                        <div className="avatar-title bg-light border rounded-circle text-muted">
                          <i className="ri-image-fill"></i>
                        </div>
                      </div>
                    </Label>
                    <Input
                      name="logo"
                      className="form-control d-none"
                      id="logo"
                      type="file"
                      accept="image/png, image/gif, image/jpeg"
                      onChange={handleImageChange}
                    />
                  </div>
                  <div className="avatar-lg p-1">
                    <div className="avatar-title bg-light rounded-circle">
                      <Zoom>
                        <img
                          src={
                            selectedImage ||
                            validation.values.logo ||
                            "https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg"
                          }
                          alt="logo"
                          id="logo"
                          className="avatar-md rounded-circle object-fit-cover"
                          style={{ cursor: "zoom-in" }}
                        />
                      </Zoom>
                    </div>
                  </div>
                </div>
                <h5 className="fs-13 mt-3">Logo Perusahaan</h5>
              </div>
            </Col>

            <Col lg={6}>
              <div className="mb-3">
                <Label htmlFor="name" className="form-label">
                  Nama <span className="text-danger">*</span>
                </Label>
                <Input
                  type="text"
                  className="form-control"
                  id="name"
                  name="name"
                  placeholder="Nama"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.name || ""}
                  invalid={
                    validation.touched.name && validation.errors.name
                      ? true
                      : false
                  }
                />
                {validation.errors.name && validation.touched.name ? (
                  <FormFeedback type="invalid">
                    {validation.errors.name}
                  </FormFeedback>
                ) : null}
              </div>
            </Col>

            <Col lg={6}>
              <div className="mb-3">
                <Label htmlFor="initial" className="form-label">
                  Inisial Perusahaan <span className="text-danger">*</span>
                </Label>
                <Input
                  disabled
                  type="text"
                  className="form-control"
                  id="initial"
                  name="initial"
                  placeholder="Inisial Perusahaan"
                  value={validation.values.initial || ""}
                />
              </div>
            </Col>

            <Col lg={6}>
              <div className="mb-3">
                <Label htmlFor="picName" className="form-label">
                  Nama PIC <span className="text-danger">*</span>
                </Label>
                <Input
                  type="text"
                  className="form-control"
                  id="picName"
                  name="picName"
                  placeholder="Nama PIC"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.picName || ""}
                  invalid={
                    validation.touched.picName && validation.errors.picName
                      ? true
                      : false
                  }
                />
                {validation.errors.picName && validation.touched.picName ? (
                  <FormFeedback type="invalid">
                    {validation.errors.picName}
                  </FormFeedback>
                ) : null}
              </div>
            </Col>

            <Col lg={6}>
              <div className="mb-3">
                <Label htmlFor="picEmail" className="form-label">
                  Email PIC <span className="text-danger">*</span>
                </Label>
                <Input
                  type="text"
                  className="form-control"
                  id="picEmail"
                  name="picEmail"
                  placeholder="Email PIC"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.picEmail || ""}
                  invalid={
                    validation.touched.picEmail && validation.errors.picEmail
                      ? true
                      : false
                  }
                />
                {validation.errors.picEmail && validation.touched.picEmail ? (
                  <FormFeedback type="invalid">
                    {validation.errors.picEmail}
                  </FormFeedback>
                ) : null}
              </div>
            </Col>

            <Col lg={6}>
              <div className="mb-3">
                <Label for="maxMember" className="form-label">
                  Maksimal Jumlah Pengguna{" "}
                  <span className="text-danger">*</span>
                </Label>
                <Input
                  type="text"
                  className="form-control"
                  id="maxMember"
                  name="maxMember"
                  placeholder="Maksimal Jumlah Pengguna"
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    validation.setFieldValue("maxMember", value);
                  }}
                  onBlur={validation.handleBlur}
                  value={validation.values.maxMember || ""}
                  invalid={
                    validation.touched.maxMember && validation.errors.maxMember
                      ? true
                      : false
                  }
                />
                {validation.errors.maxMember && validation.touched.maxMember ? (
                  <FormFeedback type="invalid">
                    {validation.errors.maxMember}
                  </FormFeedback>
                ) : null}
              </div>
            </Col>

            <Col lg={6}>
              <div className="mb-3">
                <Label htmlFor="adminMenus" className="form-label">
                  Menu Perusahaan <span className="text-danger">*</span>
                </Label>
                <Select
                  value={validation.values.adminMenus || []}
                  onChange={(e: any) => {
                    validation.setFieldValue("adminMenus", e);
                  }}
                  options={comboMenu}
                  closeMenuOnSelect={false}
                  isMulti
                  className={`basic-multi-select ${
                    validation.errors.adminMenus &&
                    validation.touched.adminMenus
                      ? "is-invalid"
                      : ""
                  }`}
                  classNamePrefix="select"
                  placeholder="Pilih Menu"
                />
                {validation.errors.adminMenus &&
                validation.touched.adminMenus ? (
                  <div className="invalid-feedback d-block">
                    {validation.errors.adminMenus}
                  </div>
                ) : null}
              </div>
            </Col>

            <Col lg={6}>
              <div className="mb-3">
                <Label htmlFor="address" className="form-label">
                  Alamat <span className="text-danger">*</span>
                </Label>
                <Input
                  type="textarea"
                  className="form-control"
                  id="address"
                  rows={3}
                  placeholder="Alamat"
                  name="address"
                  value={validation.values.address || ""}
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  invalid={
                    validation.touched.address && validation.errors.address
                      ? true
                      : false
                  }
                />
                {validation.touched.address && validation.errors.address ? (
                  <FormFeedback type="invalid">
                    {validation.errors.address}
                  </FormFeedback>
                ) : null}
              </div>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-soft-danger waves-effect waves-light material-shadow-none btn-sm"
            data-bs-dismiss="modal"
            onClick={onCloseClick}
          >
            Batal
          </button>
          <button
            type="submit"
            className="btn btn-soft-success waves-effect waves-light material-shadow-none btn-sm"
          >
            Simpan
          </button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

UpdateModalCompanies.propTypes = {
  onCloseClick: PropTypes.func,
  show: PropTypes.any,
  getData: PropTypes.func,
  data: PropTypes.any,
};

export default UpdateModalCompanies;
